import { loadMoreApplets } from "app/scripts/load_applets_list"

const ConnectPage = async () => {
  const connectPageData = JSON.parse(document.querySelector("[data-connect-page]")?.dataset?.connectPage || "{}")
  const { discoverMoreAppletsUrl } = connectPageData
  const discoverAppletsContainer = document.querySelector(".discover_applets")

  loadMoreApplets(discoverAppletsContainer, discoverMoreAppletsUrl)
}

export { ConnectPage }
